import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../Firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import axios from "axios";
import "./EditTemplate.css";

function EditTemplate() {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [placeholders, setPlaceholders] = useState([]);
  const [currentPlaceholder, setCurrentPlaceholder] = useState("");
  const [content, setContent] = useState(""); // Store content of docx file

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const templateDoc = await getDoc(doc(db, "templates", templateId));
        if (templateDoc.exists()) {
          const templateData = templateDoc.data();
          setTemplate(templateData);

          // Load the document content
          const response = await axios.get(templateData.url, {
            responseType: "arraybuffer",
          });
          const zip = new PizZip(response.data);
          const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
          });
          setContent(doc);
          setPlaceholders(templateData.placeholders || []);
        } else {
          console.error("Template not found");
        }
      } catch (error) {
        console.error("Error fetching template: ", error);
      }
    };
    fetchTemplate();
  }, [templateId]);

  const handlePlaceholderSelect = (e) => {
    setCurrentPlaceholder(e.target.value);
  };

  const handleAddPlaceholder = () => {
    if (currentPlaceholder) {
      setPlaceholders([...placeholders, currentPlaceholder]);
      setCurrentPlaceholder("");
    }
  };

  const handleSaveTemplate = async () => {
    try {
      await updateDoc(doc(db, "templates", templateId), {
        placeholders,
      });
      alert("Template saved successfully!");
      navigate("/dashboard");
    } catch (error) {
      console.error("Error saving template:", error);
      alert("Failed to save template: " + error.message);
    }
  };

  const handleDownload = () => {
    if (!content) return;

    try {
      content.setData({
        // Mock dynamic data to demonstrate how placeholders would be replaced
        "Agent Name": "John Doe",
        Address: "123 Main Street",
        "Weeks on Market": "5",
      });

      content.render();

      const output = content.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, "Generated_Template.docx");
    } catch (error) {
      console.error("Error generating document:", error);
    }
  };

  return (
    <div className="edit-template-container">
      <h1>Edit Template</h1>
      <div className="controls-container">
        <div className="field-selector">
          <select
            onChange={handlePlaceholderSelect}
            value={currentPlaceholder || ""}
          >
            <option value="" disabled>
              Select a placeholder to add
            </option>
            <option value="Agent Name">Agent Name</option>
            <option value="Address">Address</option>
            <option value="Weeks on Market">Weeks on Market</option>
          </select>
          <button onClick={handleAddPlaceholder} className="add-field-button">
            Add Placeholder
          </button>
        </div>
        <button onClick={handleSaveTemplate} className="save-template-button">
          Save Template
        </button>
        <button onClick={handleDownload} className="download-template-button">
          Download Example Document
        </button>
      </div>
      <div className="placeholders-container">
        <h3>Current Placeholders:</h3>
        <ul>
          {placeholders.map((placeholder, index) => (
            <li key={index}>{placeholder}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default EditTemplate;
